
export class EnumHelper {
    static GetDescription(e: any, id: number): string {


        if(id==null) return "";
    
        if (e[id] != null) {
            return e[e[id].toString() + "Description"];
       }
       return id.toString();
    }
}

